@use '../../../styles/Colors.scss' as Colors;
@use '../../../styles/Constants.scss' as Constants;

.dropdown-nested-item {
	position: relative;
}
  
.nested-menu {
	position: absolute;
	right: 100%; // opens to the left
	z-index: 9999;
	background-color: Colors.$col-white;
	padding: Constants.$val-spacing-s 0;
	width: fit-content;
	white-space: nowrap;
	border: 1px solid Colors.$col-greyConnection;
}

.dropdown-menu--cascade-left {
	right: 100% !important;
	left: auto !important;
}

.dropdown-menu {
	overflow: visible !important;
	padding: Constants.$val-spacing-s 0;
}

.has-submenu {
	position: relative;
	&::after {
		font-family: 'icons';
		content: "\e409";
		position: absolute;
		right: Constants.$val-spacing-s;
		margin-top: Constants.$val-spacing-xs;
		bottom: Constants.$val-spacing-xxs;
		font-size: Constants.$val-fontSizeXBig;
		color: Colors.$col-greyDark;
		display: flex;
		align-items: center;
		justify-content: center;
	}
}

.actions-icon {
	color: Colors.$col-greyFontLight;
	font-size: Constants.$val-fontSizeXBig !important;

	&:hover {
		color: Colors.$col-greyDark;
	}
}

.dropdown-divider {
	border-top: 1px solid Colors.$col-greyConnection;
	margin: Constants.$val-spacing-s 0;
}

.actions-3dot {
	min-height: 0;
	min-width: 0;
}

.no-results {
	display: flex;
	align-items: center;
	justify-content: center;
	font-size: Constants.$val-fontSizeSmall;
	background: Colors.$col-greyBackground;
}

.loading-results {
	color: var(--col-grey-700) !important;
	background: var(--col-blue-100) !important;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: Constants.$val-fontSizeSmall;
}